import React from 'react';
import { useSelector } from 'react-redux';

export default function useUserRole() {
    
    const userRole = useSelector((state: any) => state.user.userRole) || 0;

    return userRole;

}
